import React, { useRef, useState } from "react";

export const SmartVideoPlayer = ({ file, cssClass }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const videoRef = useRef(null);
  const seekTimeRef = useRef(0);


  return (
    <>
      {file?.mainPath && (
        <video
          src={file?.mainPath}
          controls
          autoPlay
          width="100%"
          controlsList="nodownload"
          className={cssClass}
        >
          The browser does not support the video tag.
        </video>
      )}
    </>
  );
};
